/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const ProjectAction = {

	get (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/project-action"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAdministrativeCosts (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/project-action/administrative-costs"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getCosts (context, projectActionId, onSuccess, onError, options) {
		Api.get(context,
			"/project-action/costs"
			+ "?projectActionId=" + projectActionId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
